// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"161f912e","548":"1f5e2338","798":"615ce0d5","828":"79d79565","833":"a5bdbab5","964":"276c2e93"}[chunkId] + ".chunk.js";
};